module.exports = __webpack_public_path__ + "static/media/youwouldntstealacar.78cfc553.gif";